import './user.css'

import React, { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom'

interface SimpleUser {
  id: string
  username: string
}

export const UserLink = ({
  user,
  ucid
}: {
  user?: SimpleUser,
  ucid?: string,
}) => {
  const navigate = useNavigate()

  return user?.id ? <>
    <span className='user-link-component user active' onClick={() => {
      navigate(`/communal/statistics/users?user=${user.id}`)
    }}>
      {user.username}
    </span>
  </> : ucid ? <span className='user-link-component card active' onClick={() => {
      navigate(`/communal/cards/manager?search=${ucid}`)
    }}>{ucid}</span> : '-'
}